import EnergyMapContent from './EnergyMapContent'
import EnergyMapController from './EnergyMapController'

export { default } from './Energy'

export const EnergyMapConfig = {
  Content: EnergyMapContent,
  Controller: EnergyMapController,
}
